import React, { useCallback } from 'react';
import { TextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '../../../contexts/translation-context';
import { classes } from '../stylesheets/signature-wut.st.css';
import { dataUrlToWixFile } from '../utils/data-url';
import { FORM_STATUS, useFormStatus } from '../../../contexts/form-status-provider';
export const SignatureFooterWUT = _ref => {
  let {
    enableUpload,
    onBlur,
    onChange,
    value,
    inputId,
    cancelUpload,
    target
  } = _ref;
  const {
    t
  } = useTranslation();
  const $input = React.useRef(null);
  const {
    setFormStatus
  } = useFormStatus();
  const handleClear = useCallback(() => {
    cancelUpload();
    onChange == null || onChange(null);
    setFormStatus(target, FORM_STATUS.READY);
  }, [cancelUpload, onChange, setFormStatus, target]);
  const handleChange = useCallback(event => {
    const fileReader = new FileReader();
    const [file] = event.target.files || [];
    if (!file) {
      return;
    }
    fileReader.onload = function () {
      onChange == null || onChange(dataUrlToWixFile(this.result, file.name));
    };
    fileReader.readAsDataURL(file);
    event.target.value = '';
  }, [onChange]);
  const handleClick = useCallback(() => {
    var _$input$current;
    (_$input$current = $input.current) == null || _$input$current.click();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    accept: "image/*",
    type: "file",
    tabIndex: -1,
    ref: $input,
    onChange: handleChange,
    className: classes.hiddenInput,
    "aria-hidden": "true"
  }), enableUpload && !value ? /*#__PURE__*/React.createElement(TextButton, {
    className: classes.upload,
    onBlur: onBlur,
    onClick: handleClick,
    priority: TextButtonPriority.primary,
    "data-input-id": inputId,
    "data-hook": "upload",
    "aria-controls": inputId
  }, t('field.signature.settings.upload-button.label')) : /*#__PURE__*/React.createElement(TextButton, {
    onBlur: onBlur,
    onClick: handleClear,
    priority: TextButtonPriority.secondary,
    "data-input-id": inputId,
    "data-hook": "clear",
    disabled: !value,
    className: classes.clear,
    "aria-controls": inputId
  }, t('field.signature.clear-button.label')));
};
//# sourceMappingURL=signature-footer-wut.js.map